import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

const Error = () => {
    return (
        <section className="dp-404">
            {/* Animated background blobs */}
            <div className="dp-404__blob dp-404__blob--1" />
            <div className="dp-404__blob dp-404__blob--2" />
            <div className="dp-404__blob dp-404__blob--3" />

            <div className="dp-404__inner">
                {/* Big number */}
                <div className="dp-404__number">
                    <span>4</span>
                    <div className="dp-404__flask">
                        <div className="dp-404__flask-body">
                            <div className="dp-404__bubble dp-404__bubble--1" />
                            <div className="dp-404__bubble dp-404__bubble--2" />
                            <div className="dp-404__bubble dp-404__bubble--3" />
                        </div>
                    </div>
                    <span>4</span>
                </div>

                <div className="dp-404__badge">Page Not Found</div>

                <h1 className="dp-404__title">Oops! This page doesn't exist.</h1>
                <p className="dp-404__sub">
                    The page you're looking for may have been moved, removed, or the URL might be incorrect.
                </p>

                <div className="dp-404__actions">
                    <Link to="/" className="dp-404__btn dp-404__btn--primary">
                        🏠 Back to Home
                    </Link>
                    <Link to="/products" className="dp-404__btn dp-404__btn--outline">
                        🧪 Browse Products
                    </Link>
                    <Link to="/contact" className="dp-404__btn dp-404__btn--outline">
                        📞 Contact Us
                    </Link>
                </div>

                <div className="dp-404__links">
                    <span>You might be looking for:</span>
                    <Link to="/products">Products</Link>
                    <Link to="/request">Request</Link>
                    <Link to="/contact">Contact</Link>
                </div>
            </div>
        </section>
    );
};

export default Error;
